var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid pointer",on:{"click":function($event){return _vm.clickGrid(_vm.item)}}},[_c('img',{attrs:{"src":_vm.imageUrl + _vm.item.studyCourse.logo,"alt":""}}),_c('p',{staticClass:"title e-2"},[_vm._v(_vm._s(_vm.item.studyCourse.name || ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }